import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductsRoutingModule } from '../products/products-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SharedModule } from 'src/app/shared/shared.module';
import { RestaurantSelectionModule } from '../restaurant-selection/restaurant-selection.module';
import { RestaurantManagementComponent } from './restaurant-management.component';
import { RestaurantManagementListComponent } from './restaurant-management-list/restaurant-management-list.component';
import { RestaurantManagementRoutingModule } from './restaurant-management-routing.module';


@NgModule({
  declarations: [
    RestaurantManagementComponent,
    RestaurantManagementListComponent
  ],
  imports: [
    Ng2SearchPipeModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ProductsRoutingModule,
    NgbModule,
    GalleryModule,
    CKEditorModule,
    NgxDropzoneModule,
    SharedModule,
    RestaurantManagementRoutingModule,
    RestaurantSelectionModule       
  ]
})
export class RestaurantManagementModule { }
